<template>
  <div class="provide-feedback-message-head">
    <p>Hi {{ client.name }}!</p>
    <p>{{ message.message }}</p>
    <span>{{ agent.name }}</span>
    <div v-if="profileStatus === 'client'">
      <button v-if="!isFeedbackProvided" type="button" class="provide-feedback-message-btn" @click="emitProvideFeedback()">
        Leave Feedback
      </button>
      <button v-else type="button" class="provide-feedback-message-btn" :disabled="true">
        Feedback already provided
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'

export default {
  props: {
    message: {
      type: Object,
      default: () => ({})
    },
    client: {
      type: Object,
      default: () => ({})
    },
    agent: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('common', ['profileStatus']),
    isFeedbackProvided() {
      const propertyId = get(this.message, 'metadata.data.thread.property_id', null)
      const clientHome = this.client.homes.find(home => home.propertyId === propertyId)
      const isFeedbackExists = get(clientHome, 'feedback.match._creator', null)
      return !!isFeedbackExists
    }
  },
  methods: {
    emitProvideFeedback() {
      this.$emit('provide-feedback-btn-clicked', this.message)
    }
  }
}
</script>

<style lang="sass" scoped>
  .provide-feedback-message-head
    width: 100%
    max-width: 600px
    margin: 0 auto
    padding: 0 0 50px 0
  .provide-feedback-message-btn
    background: $hwayzNested
    border-radius: 10px
    text-transform: uppercase
    color: #fff
    cursor: pointer
    padding: 15px 40px
    margin: 50px auto 0
    display: block
    &:disabled
      opacity: 0.6
</style>
